const REDES = [
  { key: 'whatsapp', hosts: ['wa.me', 'api.whatsapp.com', 'whatsapp.com'], icon: 'mdi-whatsapp', color: '#25D366' },
  { key: 'instagram', hosts: ['instagram.com'], icon: 'mdi-instagram', color: '#E1306C' },
  { key: 'facebook',  hosts: ['facebook.com', 'fb.com', 'm.facebook.com'], icon: 'mdi-facebook', color: '#1877F2' },
  { key: 'twitter',   hosts: ['twitter.com', 'x.com'], icon: 'mdi-twitter', color: '#1DA1F2' },
  { key: 'linkedin',  hosts: ['linkedin.com'], icon: 'mdi-linkedin', color: '#0A66C2' },
  { key: 'youtube',   hosts: ['youtube.com', 'youtu.be'], icon: 'mdi-youtube', color: '#FF0000' },
  { key: 'tiktok',    hosts: ['tiktok.com'], icon: 'mdi-music-note', color: '#000000' },
]

const COR_PADRAO = 'var(--wc-cor-primaria, #156CF7)'

export function isUrl(text) {
  if (!text) return false
  return /^https?:\/\//i.test(text) || /^www\./i.test(text)
}

function normalizarUrl(text) {
  return /^www\./i.test(text) ? `https://${text}` : text
}

function getHost(text) {
  if (!isUrl(text)) return ''
  try {
    return new URL(normalizarUrl(text)).hostname.replace(/^www\./i, '').toLowerCase()
  } catch {
    return ''
  }
}

function identificarRede(contato) {
  const host = getHost(contato.numeroendereco)
  if (host) {
    const porHost = REDES.find(r => r.hosts.some(h => host === h || host.endsWith(`.${h}`)))
    if (porHost) return porHost
  }
  const desc = (contato.descricao || '').toLowerCase()
  return REDES.find(r => desc.includes(r.key)) || null
}

export function isWhatsApp(contato) {
  const rede = identificarRede(contato)
  return rede?.key === 'whatsapp'
}

export function isSocialMedia(contato) {
  return identificarRede(contato) !== null
}

export function getIcon(contato) {
  const rede = identificarRede(contato)
  if (rede) return rede.icon
  const text = contato.numeroendereco || ''
  if (text.includes('@')) return 'mdi-email'
  if (isUrl(text)) return 'mdi-web'
  return 'mdi-phone'
}

export function getColor(contato) {
  return identificarRede(contato)?.color || COR_PADRAO
}

export function getValidUrl(contato) {
  const text = contato.numeroendereco || ''
  if (isWhatsApp(contato)) {
    if (isUrl(text)) return normalizarUrl(text)
    const numeros = text.replace(/\D/g, '')
    const numero = numeros.length <= 11 ? `55${numeros}` : numeros
    return `https://wa.me/${numero}`
  }
  return normalizarUrl(text)
}

export function getContatoApresentacao(contato) {
  const text = contato.numeroendereco || ''
  const icon = getIcon(contato)
  const color = getColor(contato)
  const social = isSocialMedia(contato)

  if (isWhatsApp(contato)) {
    return { icon, color, href: getValidUrl(contato), target: '_blank', label: text || contato.descricao, social: true }
  }
  if (social) {
    return { icon, color, href: getValidUrl(contato), target: '_blank', label: contato.descricao, social: true }
  }
  if (isUrl(text)) {
    return { icon, color, href: getValidUrl(contato), target: '_blank', label: contato.descricao, social: false }
  }
  if (icon === 'mdi-phone') {
    return { icon, color, href: `tel:${text.replace(/\D/g, '')}`, target: null, label: text, social: false }
  }
  if (icon === 'mdi-email') {
    return { icon, color, href: `mailto:${text}`, target: null, label: text, social: false }
  }
  return { icon, color, href: null, target: null, label: `${contato.descricao}: ${text}`, social: false }
}
